/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalInfoResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'all-of',
        contains: [{
          type: 'ProfessionalInfoResponseData',
        }],
        isRequired: true,
      },
    },
  }],
} as const;
